import { produce } from 'immer';

import { ResetInternalMarketerEditProduct } from '../../../actions/marketer/internal/resetInternalMarketerEditProduct';
import { MarketerState } from '../../../typings/marketers';
import { getMarketerInitialState } from '../internal';

export function resetInternalMarketerEditProduct(
    state: MarketerState,
    action: ResetInternalMarketerEditProduct
): MarketerState {
    return produce(state, draft => {
        draft.editProduct = getMarketerInitialState().editProduct;
    });
}
